import Reveal from "./Reveal";
import { CONTACT, IMAGES } from "@/data/content";

const ABOUT_IMG = IMAGES.schlafzimmerFloral;

export default function About() {
    return (
        <section
            id="ueber-uns"
            data-testid="about-section"
            className="section-y relative"
        >
            <div className="container-em grid lg:grid-cols-12 gap-10 md:gap-16 items-center">
                <Reveal className="lg:col-span-5 order-2 lg:order-1">
                    <div className="relative">
                        <div className="overflow-hidden rounded-3xl aspect-[4/5] shadow-[0_20px_60px_-20px_rgba(60,60,50,0.25)]">
                            <img
                                src={ABOUT_IMG}
                                alt="Heller Wohnbereich der Ferienwohnung Emsglück"
                                loading="lazy"
                                className="h-full w-full object-cover transition-transform duration-[1400ms] hover:scale-105"
                            />
                        </div>
                        <div className="hidden md:block absolute -bottom-6 -right-6 w-40 h-40 rounded-3xl bg-secondary/60 -z-10" />
                        <div className="hidden md:block absolute -top-6 -left-6 w-24 h-24 rounded-full bg-primary/15 -z-10" />
                    </div>
                </Reveal>

                <div className="lg:col-span-7 order-1 lg:order-2 lg:pl-6">
                    <Reveal>
                        <span className="font-accent text-xs uppercase tracking-[0.3em] text-primary">
                            Über uns
                        </span>
                    </Reveal>
                    <Reveal delay={0.05}>
                        <h2
                            data-testid="about-title"
                            className="mt-4 font-display text-4xl sm:text-5xl md:text-6xl leading-[1.05] tracking-tight text-foreground text-balance"
                        >
                            Willkommen im{" "}
                            <em className="not-italic text-primary">
                                Emsglück
                            </em>
                            .
                        </h2>
                    </Reveal>
                    <Reveal delay={0.1}>
                        <div className="mt-8 space-y-5 text-foreground/75 text-lg leading-relaxed max-w-xl">
                            <p>
                                Ob beruflich unterwegs, mit der Familie im
                                Urlaub oder auf einem entspannten Kurztrip – im
                                Emsglück bist Du genau richtig.
                            </p>
                            <p>
                                Unsere liebevoll eingerichtete Ferienwohnung
                                bietet Dir eine ruhige Atmosphäre, viel Komfort
                                und alles, was Du für einen angenehmen
                                Aufenthalt brauchst.
                            </p>
                            <p>
                                Nach einem langen Arbeitstag kannst Du hier
                                abschalten und neue Energie tanken. Familien
                                genießen gemeinsame Zeit und entdecken Papenburg
                                und das Emsland.
                            </p>
                        </div>
                    </Reveal>

                    <Reveal delay={0.15}>
                        <div className="mt-10 flex flex-wrap items-center gap-x-8 gap-y-3 font-display text-2xl sm:text-3xl text-foreground/85">
                            <span>Ankommen.</span>
                            <span className="h-1 w-1 rounded-full bg-primary" />
                            <span>Wohlfühlen.</span>
                            <span className="h-1 w-1 rounded-full bg-primary" />
                            <span className="italic text-primary">
                                Entspannen.
                            </span>
                        </div>
                    </Reveal>

                    <Reveal delay={0.2}>
                        <a
                            href="#anfrage"
                            data-testid="about-inquiry-button"
                            className="mt-10 inline-flex items-center gap-2 text-primary hover:text-primary/80 transition-colors font-medium border-b border-primary/40 hover:border-primary pb-1"
                        >
                            Jetzt unverbindlich anfragen →
                        </a>
                    </Reveal>
                </div>
            </div>
        </section>
    );
}
